import React from 'react';
import { AccordionContainer } from '../../components/accordion/accordion.module';
import { InputContainer } from '../../components/form/form.module';

export const AddressComponent = ({ libraries, countries, isAddress, onInnerFormChange, selectedAddress, stateValues, onFilterToStates }: any) => (
  <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Address1"
          name="Address1"
          onValueChange={(event: any) => {
            onInnerFormChange(
              event.target.value,
              'PrimaryAddress.Address1',
              selectedAddress?.PrimaryAddress
            )
          }}
          type="text"
          value={selectedAddress?.PrimaryAddress?.Address1}
        />
        <InputContainer
          label="Address2"
          name="Address2"
          onValueChange={(event: any) => {
            onInnerFormChange(
              event.target.value,
              'PrimaryAddress.Address2',
              selectedAddress?.PrimaryAddress
            )
          }}
          type="text"
          value={selectedAddress?.PrimaryAddress?.Address2}
        />
        <InputContainer
          label="City"
          name="City"
          onValueChange={(event: any) => {
            onInnerFormChange(
              event.target.value,
              'PrimaryAddress.City',
              selectedAddress?.PrimaryAddress
            )
          }}
          type="text"
          value={selectedAddress?.PrimaryAddress?.City}
        />
        <InputContainer

          label="Country Name"
          labelField="Name"
          list={countries}
          onValueChange={(event: any) => {
            onFilterToStates(event.target.value);

          }}
          optionName="Choose Country"
          type="select"
          value={selectedAddress?.PrimaryAddress?.CountryId}
          valueField="Id"
        />
        <InputContainer

          label="State Name"
          labelField="Name"
          list={stateValues}
          onValueChange={(event: any) => {
            onInnerFormChange(
              event.target.value,
              'PrimaryAddress.StateProvinceId',
              selectedAddress?.PrimaryAddress
            );
          }}
          optionName="Choose State"
          type="select"
          value={selectedAddress?.PrimaryAddress?.StateProvinceId}
          valueField="Id"
        />
        <InputContainer
          label="ZipPostalCode"
          name="ZipPostalCode"
          onValueChange={(event: any) => {
            onInnerFormChange(
              event.target.value,
              'PrimaryAddress.ZipPostalCode',
              selectedAddress?.PrimaryAddress
            )
          }}
          type="text"
          value={selectedAddress?.PrimaryAddress?.ZipPostalCode}
        />
        {isAddress
          ? <>
            <InputContainer
              label="FaxNumber"
              name="FaxNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PrimaryAddress.FaxNumber',
                  selectedAddress?.PrimaryAddress
                )
              }}
              type="number"
              value={selectedAddress?.PrimaryAddress?.FaxNumber}
            />
            <InputContainer
              label="OpeningHours Type"
              labelField="Description"
              list={libraries.OpeningHoursType}
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PrimaryAddress.OpeningHoursTypeId',
                  selectedAddress?.PrimaryAddress
                );
              }}

              type="select"
              value={selectedAddress?.PrimaryAddress?.OpeningHoursTypeId}
              valueField="Value"
            />
            <InputContainer
              label="Geocode Accuracy"
              name="GeocodeAccuracy"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PrimaryAddress.GeocodeAccuracy',
                  selectedAddress?.PrimaryAddress
                )
              }}
              type="text"
              value={selectedAddress?.PrimaryAddress?.GeocodeAccuracy}
            />

            <InputContainer
              label="Latitude"
              name="Latitude"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PrimaryAddress.Latitude',
                  selectedAddress?.PrimaryAddress
                )
              }}
              type="text"
              value={selectedAddress?.PrimaryAddress?.Latitude}
            />
            <InputContainer
              label="Longitude"
              name="Longitude"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PrimaryAddress.Longitude',
                  selectedAddress?.PrimaryAddress
                )
              }}
              type="text"
              value={selectedAddress?.PrimaryAddress?.Longitude}
            />
          </>
          : null}
      </div>

    }
    expandedPanel="primaryAddressInfo"
    headerTitle="PrimaryAddress Info"
  />
)
